// frontend_react/src/services/cashRegisterApi.js

import api, { buildCompanyScopeHeaders } from "./api";

export async function getCashRegisterDashboard({ companyUuid } = {}) {
  const response = await api.get("/admin/cash-register/dashboard", {
    headers: buildCompanyScopeHeaders(companyUuid),
  });
  return response.data;
}

export async function getCashRegisterXReport({ companyUuid } = {}) {
  const response = await api.get("/admin/cash-register/x-report", {
    headers: buildCompanyScopeHeaders(companyUuid),
  });
  return response.data;
}

export async function openGlobalCashSession(payload, { companyUuid } = {}) {
  const response = await api.post("/certifications/open", payload, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });
  return response.data;
}

export async function closeGlobalCashSession(
  cashSessionUuid,
  payload,
  {
    companyUuid,
    activityUuid,
  } = {}
) {
  const response = await api.post(
    `/certifications/close/${cashSessionUuid}`,
    {
      ...payload,
      activity_uuid:
        activityUuid
        ?? payload?.activity_uuid
        ?? null,
    },
    {
      headers:
        buildCompanyScopeHeaders(
          companyUuid
        ),
    }
  );
  return response.data;
}

export async function getCurrentCashSession({
  companyUuid,
  activityUuid,
} = {}) {
  const response = await api.get(
    "/certifications/current",
    {
      params: {
        activity_uuid:
          activityUuid
          ?? undefined,
      },
      headers:
        buildCompanyScopeHeaders(
          companyUuid
        ),
    }
  );
  return response.data;
}

export const getCashSessionHistory = async ({
  companyUuid,
  activityUuid,
} = {}) => {
  const response = await api.get(
    "/certifications/history",
    {
      params: {
        activity_uuid:
          activityUuid
          ?? undefined,
      },
      headers:
        buildCompanyScopeHeaders(
          companyUuid
        ),
    }
  );
  return response.data;
};

export async function getZReportDetail(
  cashSessionUuid,
  {
    companyUuid,
    activityUuid,
  } = {}
) {
  const response = await api.get(
    `/certifications/${cashSessionUuid}/z-report`,
    {
      params: {
        activity_uuid:
          activityUuid
          ?? undefined,
      },
      headers:
        buildCompanyScopeHeaders(
          companyUuid
        ),
    }
  );
  return response.data;
}

export async function sendZReportByEmail(cashSessionUuid, payload = {}, { companyUuid } = {}) {
  const response = await api.post(
    `/certifications/${cashSessionUuid}/z-report/email`,
    payload,
    {
      headers: buildCompanyScopeHeaders(companyUuid),
    }
  );
  return response.data;
}

export async function sendZReportToAccounting(cashSessionUuid, { companyUuid } = {}) {
  const response = await api.post(
    `/certifications/${cashSessionUuid}/z-report/accounting`,
    {},
    {
      headers: buildCompanyScopeHeaders(companyUuid),
    }
  );
  return response.data;
}

export function getZReportPdfUrl(cashSessionUuid, companyUuid = null) {
  const query = companyUuid ? `?company_uuid=${encodeURIComponent(companyUuid)}` : "";
  return `/api/certifications/${cashSessionUuid}/z-report/pdf${query}`;
}